//element ui
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/de';

//vue.js
import Vue from 'vue'
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';

//basic components
import App from './components/App.vue';
import Navigation from './components/pageLayout/Navigation.vue';

//location components
import Signin from './components/locations/Signin.vue';
import Home from './components/locations/Home.vue';
import Child from './components/locations/Child';
import Session from './components/locations/Session';
import Profile from './components/locations/Profile.vue';
import Weekly from './components/locations/Weekly.vue';
import Therapist from "./components/locations/Therapist";
import Lead from './components/locations/Lead.vue';
import Admin from './components/locations/Admin.vue';
import ActivateEmail from './components/locations/ActivateEmail.vue';
import ActivateAccount from './components/locations/ActivateAccount.vue';
import ResetPassword from "./components/locations/ResetPassword";
import Privacy from './components/locations/Privacy';
import Terms from './components/locations/Terms';

import auth from './auth.js';

Vue.use(ElementUI, {locale});
Vue.use(VueRouter);
Vue.use(VueResource);

// Vue.http.headers.common['X-CSRF-TOKEN'] = document.getElementsByName('csrf-token')[0].getAttribute('content');
// Vue.http.options.root = 'http://localhost/schiffsregister/public';
Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token');

export default Vue;

export const router = new VueRouter({
    routes: [
        /*
        * component locations requiring authentication, linked in navigation
         */
        {
            path: '/',
            name: 'home',
            component: Home,
            props: true,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/weekly',
            name: 'weekly',
            component: Weekly,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/lead',
            name: 'lead',
            component: Lead,
            meta: {
                requiresAuth: true,
                permission: auth.permissions.IS_LEADER
            }
        },
        {
            path: '/admin',
            name: 'admin',
            component: Admin,
            meta: {
                requiresAuth: true,
                permission: auth.permissions.IS_ADMIN
            }
        },
        {
            path: '/child/:childId',
            name: 'child',
            component: Child,
            props: true,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/session/:sessionId',
            name: 'session',
            component: Session,
            props: true,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/create-therapist',
            name: 'create-therapist',
            component: Therapist,
            props: true,
            meta: {
                requiresAuth: true,
                permission: auth.permissions.IS_LEADER
            }
        },

        /*
        * routes without authentication
         */
        {
            path: '/signin',
            name: 'signin',
            component: Signin
        },
        {
            path: '/activate-email',
            name: 'activate-email',
            component: ActivateEmail
        },
        {
            path: '/activate-account',
            name: 'activate-account',
            component: ActivateAccount
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            component: ResetPassword
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy
        },
        {
            path: '/terms',
            name: 'terms',
            component: Terms
        }
    ]
});

//setup router security
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        // if there is jwt in localStorage but user seems to be not authenticated,
        // then double check via server if user auth (will happen on pagereload)
        if (localStorage.getItem('id_token') !== null && auth.user.authenticated === false) {
            auth.verifyToken(checkPermissions);
        } else {
            checkPermissions()
        }

        function checkPermissions() {
            if(to.meta.hasOwnProperty('permission')) {
                if (auth.user.authenticated && auth.user.profile.permissions[to.meta.permission]) {
                    next();
                } else {
                    console.log("ERROR - No permissions, client is clearing token ...");
                    auth.clearToken();
                    next({name: 'signin'})
                }
            } else {
                //console.log("PASS - Basic user is allowed to access this route");
                next();
            }
        }
    } else {
        next();
    }
});

//create interceptor for general handling of 401
Vue.http.interceptors.push(function (request, next) {
    next(function (response) {
        if (response.status === 401) {
            console.log("ERROR - 401 client will clear token ...");
            auth.clearToken();
            return response
        }
    })
});


//initialize VUE instance
// export const VueInstance = new Vue({
export const VueInstance = new Vue({
    el: '#app',
    router: router,
    render: app => app(App),
    components: {
        'navigation': Navigation
    }
});
